module.exports = __webpack_public_path__ + "static/img/A10.78e3e3e7.jpg";